import { useState } from 'react'
import type { Book } from '../../shared/types'

export function BookCover({ book }: { book: Book }) {
  const [missing, setMissing] = useState(false)

  if (missing) {
    return (
      <div className="book-cover book-cover-placeholder" aria-label={`Capa de ${book.title} ainda não disponível`}>
        <span>Fecomércio Goiás</span>
        <strong>{book.title}</strong>
      </div>
    )
  }

  return (
    <img
      className="book-cover"
      src={`/api/covers/${book.id}`}
      alt={`Capa: ${book.title}`}
      onError={() => setMissing(true)}
    />
  )
}
